import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { denormalisedResponseEntities } from '../../util/data';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  Page,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  LayoutSingleColumn,
  Footer
} from '../../components';
import { TopbarContainer } from '../../containers';
import { featProductCatalog } from '../../ducks/productCatalog.duck';
import { useSdk } from '../../sdkContext';
import { parse } from '../../util/urlHelpers';
import SubscriptionListingForm from './SubscriptionListingForm';
import css from './EditSubscriptionListingPage.css';

const EditSubscriptionListingPageComponent = props => {
  const {
    productCatalog,
    currentUserProviders,
    params,
    intl,
    history
  } = props;

  const sdk = useSdk();
  const dispatch = useDispatch();
  const { id } = params;
  const isEdit = !!id && params.type !== 'new';
  const isNew = params.type === 'new';

  const queryParams = parse(props.location.search);
  const urlProviderId = queryParams.providerId;

  const [existingListing, setExistingListing] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(featProductCatalog({}));

    if (isEdit) {
      sdk.newSdk.subscriptionListings.show({ id, include: ['provider', 'catalogItem'] })
        .then(response => {
          const denormalized = denormalisedResponseEntities(response);
          setExistingListing(denormalized[0]);
        })
        .catch(e => {
          console.error(e);
          setFetchError(intl.formatMessage({ id: 'EditSubscriptionListingPage.fetchError' }));
        });
    }
  }, [id, isEdit, dispatch]);

  const handleSubmit = values => {
    setIsSubmitting(true);
    const { providerId, catalogProductId, price, managedAmount, minDurationMonths, ...rest } = values;

    const payload = {
      ...rest,
      price: parseFloat(price) * 100,
      managedAmount: parseInt(managedAmount, 10),
      minDurationMonths: parseInt(minDurationMonths, 10),
    };

    const call = isEdit
      ? sdk.newSdk.subscriptionListings.update({ ...payload, id })
      : sdk.newSdk.subscriptionListings.create({ ...payload, providerId });

    call
      .then(response => {
        const pId = values.providerId || response.data.data.attributes.providerId;
        history.push(`/subscription-listings/${pId}`);
      })
      .catch(e => {
        setIsSubmitting(false);
        console.error(e);
      });
  };

  const title = intl.formatMessage({
    id: isNew ? 'EditSubscriptionListingPage.titleNew' : 'EditSubscriptionListingPage.titleEdit',
  });

  if (isEdit && !existingListing && !fetchError) {
    return (
      <Page title={title}>
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer />
          </LayoutWrapperTopbar>

          <LayoutWrapperMain className={css.mainWrapper}>
            <div className={css.loading}>Ładowanie danych...</div>
          </LayoutWrapperMain>

        </LayoutSingleColumn>
      </Page>);
  }

  const catalogItemTitle = existingListing?.attributes?.title || 'Produkt z katalogu';

  return (
    <Page title={title}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.mainWrapper}>
          <div className={css.content}>
            <div className={css.headingContainer}>
              <h1 className={css.title}>{title}</h1>
              {fetchError && <p className={css.errorText}>{fetchError}</p>}
              <p className={css.subtitle}>
                {isNew
                  ? 'Skonfiguruj parametry nowej subskrypcji dla wybranego produktu.'
                  : 'Zaktualizuj warunki najmu i dostępność.'}
              </p>
            </div>

            <div className={css.formContainer}>

              <SubscriptionListingForm
                productCatalog={productCatalog}
                providers={currentUserProviders}
                onSubmit={handleSubmit}
                isSubmitting={isSubmitting}
                catalogItemTitle={catalogItemTitle}
                isEdit={isEdit}
                initialValues={existingListing ? {
                  providerId: existingListing?.provider?.id?.uuid,
                  catalogItemId: existingListing?.catalogItem?.id?.uuid,
                  price: existingListing.attributes.price.amount / 100,
                  state: existingListing.attributes.state,
                  managedAmount: existingListing.attributes.managedAmount,
                  minDurationMonths: existingListing.attributes.minDurationMonths
                } : {
                  providerId: urlProviderId || null,
                  state: 'published',
                  managedAmount: 1,
                  minDurationMonths: 1
                }}
              />
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { productCatalog } = state.productCatalog;
  const { userProviders } = state.user;

  return {
    productCatalog: getMarketplaceEntities(state, productCatalog),
    currentUserProviders: userProviders,
  };
};

export default compose(
  withRouter,
  injectIntl,
  connect(mapStateToProps)
)(EditSubscriptionListingPageComponent);